import React from 'react';
import './index.css';
import {Navbar, Nav, NavItem, Image, Well, Row, Col} from 'react-bootstrap';
import Contact from './Contact';



class SideBar extends React.Component{
  handleSelect(eventKey){
    let urls=["https://asunews.asu.edu/20151005-hacks-humanity-social-good#.VhNGDTwutwk.twitter","http://www.ijirst.org/Article.php?manuscript=IJIRSTV1I10001","https://asunow.asu.edu/20160603-independent-living","https://devpost.com/software/haterdetector-hjm37k"];
    window.location = urls[eventKey-1];
  }
  render(){
    return(
    <div>
      <h3>On the Web</h3>
        <Nav bsStyle="tabs" onSelect={this.handleSelect}>
	        <Row>
	        	<Col xs={12} md={6}>
	        		<NavItem eventKey={1} href="https://asunews.asu.edu/20151005-hacks-humanity-social-good#.VhNGDTwutwk.twitter">Won 1st Prize at Hackathon</NavItem>
	        	</Col>
	        	<Col xs={12} md={6}>
	        		<NavItem eventKey={2} href="http://www.ijirst.org/Article.php?manuscript=IJIRSTV1I10001">Publication on using Mobile Applications for Accident Detection</NavItem>
	        	</Col>
	        	<Col xs={12} md={6}>
	        		<NavItem eventKey={3} href="https://asunow.asu.edu/20160603-independent-living">Project for Visually Disabled mentioned on ASU News</NavItem>
	        	</Col>
	        	<Col xs={12} md={6}>
	        		<NavItem eventKey={4} href="https://devpost.com/software/haterdetector-hjm37k">Winner of the Best Social Award Winner at DesertHacks</NavItem>
	        	</Col>
	        </Row>
        </Nav>
    </div>
        
      );
  }
}



class NavbarInstance extends React.Component{
	handleSelect2(eventKey){
		let urls=["https://linkedin.com/in/mishrakrishnakant",
		"https://github.com/mishrakrishnakant",
		"http://devpost.com//krishnakant",
		"http://stackoverflow.com/story/mishrakrishnakant",
		"https://www.hackerrank.com//kmishra3"];
		window.location = urls[eventKey-1];
	}
	render(){
		return(
			<Navbar inverse fixedBottom collapseOnSelect>
				<Navbar.Header>
					<Navbar.Toggle />
				</Navbar.Header>
			    <Navbar.Collapse>
			      <Nav onSelect={this.handleSelect2}>
			        <NavItem eventKey={1} href="https://linkedin.com/in/mishrakrishnakant">LinkedIn</NavItem>
			        <NavItem eventKey={2} href="https://github.com/mishrakrishnakant">Github</NavItem>
			        <NavItem eventKey={3} href="http://devpost.com//krishnakant">DevPost</NavItem>
			        <NavItem eventKey={4} href="http://stackoverflow.com/story/mishrakrishnakant">StackOverflow</NavItem>
			        <NavItem eventKey={5} href="https://www.hackerrank.com//kmishra3">HackerRank</NavItem>
			      </Nav>
			      <Navbar.Form pullRight>
			        	<Contact/>
			    </Navbar.Form>
			    </Navbar.Collapse>
			    
  			</Navbar>
			);
	}
}
class Header extends React.Component{
	render(){
		return(
			<div className="container-fluid">
				<Well>
				<Row>
			      <Col xs={12} md={6}>
			          <Row>
			            <Col xs={12} md={4}>
			              <Image bsStyle="pullLeft" circle width="150" height="150" src={require('../images/profile_photo.jpg')}/>
			            </Col>
			            <Col xs={12} md={8}>
			              <h1 bsStyle="pullRight">I <i className="fa fa-heart" fa-3x aria-hidden="true"></i> building solutions!</h1>
			              <h4>I am looking for a great company to work with starting September 2017. Drop in your name and email below if you are hiring for my skills!</h4>
			            </Col>
			          </Row>
			    
			      </Col>
			      <Col xs={12} md={6}>
			        <SideBar />
			      </Col>

			     </Row>
			     </Well>
			     <hr className="break"/>
			   </div>
			);
	}
	
}

export {Header, NavbarInstance};


// WEBPACK FOOTER //
// ./src/Header.js